"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphNumberingReferenceNumberingIdDestination = void 0;
var tslib_1 = require("tslib");
var numbering_list_1 = require("../../../../core/model/numbering-lists/numbering-list");
var constants_1 = require("@devexpress/utils/lib/constants");
var destination_1 = require("../destination");
var ParagraphNumberingReferenceNumberingIdDestination = (function (_super) {
    tslib_1.__extends(ParagraphNumberingReferenceNumberingIdDestination, _super);
    function ParagraphNumberingReferenceNumberingIdDestination(data, parentDestination) {
        var _this = _super.call(this, data) || this;
        _this.parentDestination = parentDestination;
        return _this;
    }
    ParagraphNumberingReferenceNumberingIdDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var numberingId;
            return tslib_1.__generator(this, function (_a) {
                numberingId = this.data.readerHelper.getWpSTIntegerValue(reader, 'val', constants_1.Constants.MIN_SAFE_INTEGER);
                if (numberingId == 0)
                    numberingId = numbering_list_1.NumberingListBase.NoNumberingListIndex;
                this.parentDestination.numberingId = numberingId;
                return [2];
            });
        });
    };
    return ParagraphNumberingReferenceNumberingIdDestination;
}(destination_1.LeafElementDestination));
exports.ParagraphNumberingReferenceNumberingIdDestination = ParagraphNumberingReferenceNumberingIdDestination;
